export default {
  NFT_ADDRESS: '0x5d7e1416748Ef9cAdBFee21B924E1d4A7a1e03F4',
  NFT_MARKETPLACE_ADDRESS: '0x8d5B548AeE4a3F5C7015EE8A650DDcD05c43799f',
  USDT_ADDRESS: '0x3cf3d33eff82E62cefa5271Df25Bb3800d58B421',
  STAKE_ADDRESS: '0x437fe7191429B30D72Fb59Ed2186B4127752956d',
  PANCAKE_ADDRESS: '0xb3c07797BB5f69c246765f7E6C526eb5b2482F6c',
  ORACLE_ADDRESS: '0x0857811C25E9cE0C57ccD6aFC6BB7Aa5Bf9Be360',
  TOKEN_TGF_ADDRESS: '0x24DDDD8b8e269Bb9662C4fC0E70eCdCd5474e680',
}
